import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 可以在这里定义需要管理的状态，如 token
    token: localStorage.getItem('token') || ''
  },
  getters: {
    token: state => state.token
  },
  mutations: {
    // 定义修改状态的方法
    SET_TOKEN: (state, token) => {
      state.token = token
      localStorage.setItem('token', token) // 持久化存储
    }
  },
  actions: {},
  modules: {}
})
